exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".active[data-v-0fe7b98a]{font-weight:700}.active[data-v-0fe7b98a]:before{content:\"\";position:absolute;width:100%;height:3px;background-color:var(--portalPrimaryTextColor);bottom:-7px}.sub-nav-item[data-v-0fe7b98a]:hover{color:var(--portalPrimaryColor)}", ""]);

// exports
